window.updateQuickSearchDOM = function(searchTerm, resultsContainer){
  if(window.searchResult && resultsContainer){
    resultsContainer.innerHTML = `
    <div class="qs_suggestions">
      <div class="search_tab"></div>
      <div class="search_tabs_content"></div>
    </div>`;
    const resultsMarkup = new DOMParser().parseFromString(window.searchResult, 'text/html').querySelector('#shopify-section-quick-search-advance');

    // Function to recursively highlight text content
    function highlightText(node) {
      // Skip nodes that are not text nodes
      if (node.nodeType === 3) { // 3 means it's a text node
        const text = node.nodeValue;
        const regex = new RegExp(`(${searchTerm})`, 'gi');

        // Replace matching text with highlighted text
        const newHTML = text.replace(regex, '<span class="highlight">$1</span>');

        // Replace the text node with a new span element containing the highlighted text
        if (newHTML !== text) {
          const span = document.createElement('span');
          span.innerHTML = newHTML;
          node.parentNode.replaceChild(span, node);
        }
      } else {
        // If it's an element node, recursively check its children
        node.childNodes.forEach(child => highlightText(child, searchTerm));
      }
    }

    // Start the highlighting process
    highlightText(resultsMarkup);

    let popupResultCount = 0;

    //-- Completing tabs for quick popup...
    const resultsMarkupTabsForPopup = resultsMarkup.querySelector('#shopify-section-advance-search-tabs-quick');
    if (resultsMarkupTabsForPopup) {
      const targetElementForPopup = resultsContainer.querySelector('.search_tab');
      if (targetElementForPopup) {
        while (resultsMarkupTabsForPopup.children.length > 0) {
          targetElementForPopup.appendChild(resultsMarkupTabsForPopup.children[0]);
        }
      }
    }

    //-- Completing results for quick popup...
    const resultsMarkupForPopup = resultsMarkup.querySelector('#shopify-section-advance-search-results-quick');
    if (resultsMarkupForPopup) {
      const targetElementResultForPopup = resultsContainer.querySelector('.search_tabs_content');
      if (targetElementResultForPopup) {
        while (resultsMarkupForPopup.children.length > 0) {
          targetElementResultForPopup.appendChild(resultsMarkupForPopup.children[0]);
        }
      }
    }

    //--Manage search group for popup...
    var checkProductCount = resultsContainer.querySelectorAll('[data-search-tab-slider-qr=products] .s_product_item_list .product-item-search');
    if(checkProductCount && checkProductCount.length < 4){
      var fillProduct = document.querySelector('.searchGroupAll_wrap .swiper-slide');
      var fillTarget = resultsContainer.querySelector('[data-search-tab-slider-qr=qs_alle] .qs_r_all_left_inner');

      var blockElement = document.createElement('div');
      blockElement.className = 's_product_item_list_block';
      blockElement.innerHTML = fillProduct.querySelector('.s_r_heading').outerHTML;

      var fillProductContent = fillProduct.querySelectorAll('.s_product_item_list .product-item-search');
      if(fillProductContent && fillProductContent.length > 0){
        var productListElement = document.createElement('div');
        productListElement.className = 's_product_item_list';

        var countTakeProduct = 4 - checkProductCount.length;
        for (let index = 0; index < countTakeProduct && index < fillProductContent.length; index++) {
          var productItemWrapper = document.createElement('div');
          productItemWrapper.innerHTML = fillProductContent[index].outerHTML;
          productListElement.appendChild(productItemWrapper.firstChild);
        }
        blockElement.appendChild(productListElement);
      }
      fillTarget.appendChild(blockElement);
    }

    //-- Completing total counts for popup...
    var popupProducts = resultsContainer.querySelector('[data-tab-count-product-quick]');
    if(popupProducts){
      popupResultCount += parseInt(popupProducts.dataset.tabCountProductQuick);
    }
    var popupCollections = resultsContainer.querySelector('[data-tab-count-collection-quick]');
    if(popupCollections){
      popupResultCount += parseInt(popupCollections.dataset.tabCountCollectionQuick);
    }
    var popupActicles = resultsContainer.querySelector('[data-tab-count-article-quick]');
    if(popupActicles){
      popupResultCount += parseInt(popupActicles.dataset.tabCountArticleQuick);
    }
    var popupPages = resultsContainer.querySelector('[data-tab-count-page-quick]');
    if(popupPages){
      popupResultCount += parseInt(popupPages.dataset.tabCountPageQuick);
    }
    if(popupResultCount == 0){
      resultsContainer.classList.add('hidden');
      document.querySelector('.qs_not_found')?.classList.remove('hidden');
    }else{
      resultsContainer.classList.remove('hidden');
      document.querySelector('.qs_not_found')?.classList.add('hidden');
    }
    window.loadScriptsByAttribute('data-swiper-load');
  }
}
  
document.addEventListener("click", async function(event){
  if(event.target.hasAttribute('data-search-tab')){
    var searchTab = event.target.dataset.searchTab;
    var searchTabSlider = document.querySelectorAll('[data-search-tab-slider]');
    searchTabSlider.forEach(function(ele){
      if(ele.dataset.searchTabSlider == searchTab){
        ele.classList.remove('hidden');
      }else{
        ele.classList.add('hidden');
      }
    });
    if(document.querySelector(`.active[data-search-tab]`)){
      document.querySelector(`.active[data-search-tab]`).classList.remove('active');
    }
    event.target.classList.add('active');
    if(window.screen.width < 768){
      event.target.scrollIntoView({ 
        behavior: 'smooth', 
        block: 'center', 
        inline: 'center' 
      });
    }

  }else if(event.target.hasAttribute('data-search-tab-qr')){
    var searchTab = event.target.dataset.searchTabQr;
    var searchTabSlider = document.querySelectorAll('[data-search-tab-slider-qr]');
    searchTabSlider.forEach(function(ele){
      if(ele.dataset.searchTabSliderQr == searchTab){
        ele.classList.remove('hidden');
      }else{
        ele.classList.add('hidden');
      }
    });
    if(document.querySelector(`.active[data-search-tab-qr]`)){
      document.querySelector(`.active[data-search-tab-qr]`).classList.remove('active');
    }
    event.target.classList.add('active');
    if(window.screen.width < 768){
      event.target.scrollIntoView({ 
        behavior: 'smooth', 
        block: 'center', 
        inline: 'center' 
      });
    }
  }else if(event.target.hasAttribute('data-search-tab-sp')){
    var searchTab = event.target.dataset.searchTabSp;
    var searchTabSlider = document.querySelectorAll('[data-search-tab-slider-sp]');
    searchTabSlider.forEach(function(ele){
      if(ele.dataset.searchTabSliderSp == searchTab){
        ele.classList.remove('hidden');
      }else{
        ele.classList.add('hidden');
      }
    });
    if(document.querySelector(`.active[data-search-tab-sp]`)){
      document.querySelector(`.active[data-search-tab-sp]`).classList.remove('active');
    }
    event.target.classList.add('active');
    if(window.screen.width < 768){
      event.target.scrollIntoView({ 
        behavior: 'smooth', 
        block: 'center', 
        inline: 'center' 
      });
    }
  }
});